var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhotosReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.05714C0 0.9225 0.896875 0 2 0H14C15.1031 0 16 0.9225 16 2.05714V12.3429C16 13.4775 15.1031 14.4 14 14.4H2C0.896875 14.4 0 13.4775 0 12.3429V2.05714ZM10.1187 5.48036C9.97812 5.26821 9.74688 5.14286 9.5 5.14286C9.25312 5.14286 9.01875 5.26821 8.88125 5.48036L6.1625 9.58179L5.33437 8.51786C5.19062 8.33464 4.975 8.22857 4.75 8.22857C4.525 8.22857 4.30625 8.33464 4.16563 8.51786L2.16563 11.0893C1.98438 11.3207 1.95 11.6389 2.075 11.9057C2.2 12.1725 2.4625 12.3429 2.75 12.3429H13.25C13.5281 12.3429 13.7844 12.1854 13.9125 11.9314C14.0406 11.6775 14.025 11.3721 13.8687 11.1375L10.1187 5.48036ZM3.5 5.14286C3.89782 5.14286 4.27936 4.98031 4.56066 4.69096C4.84196 4.40162 5 4.00919 5 3.6C5 3.19081 4.84196 2.79838 4.56066 2.50904C4.27936 2.21969 3.89782 2.05714 3.5 2.05714C3.10218 2.05714 2.72064 2.21969 2.43934 2.50904C2.15804 2.79838 2 3.19081 2 3.6C2 4.00919 2.15804 4.40162 2.43934 4.69096C2.72064 4.98031 3.10218 5.14286 3.5 5.14286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotosReceived);
export default __webpack_public_path__ + "static/media/icon-photos-received.b5f46246b013962713dbfe497b96cdda.svg";
export { ForwardRef as ReactComponent };